export function multiline(paper: Snap.Paper, x: number, y: number, txt: string) {
    const txtArr: string[] = txt.split('\n');
    const t = paper.text(x, y, txtArr);
    t.selectAll('tspan:nth-child(n+2)').attr({
        dy: '1.2em',
        x: x
    });
    return t;
}
